module.exports = __webpack_public_path__ + "static/media/linkedin.3ad7a9c6.svg";